import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/components/trans';
import {
  InlineBanner,
  InlineBannerLayoutTypesEnum,
  InlineBannerTypesEnum,
} from '../../../../../libs/shared/ui/src/components/banners/inlineBanner/inlineBanner';
import {InlineLinkButton} from '../../../../../libs/shared/ui/src/components/buttons/inlineLinkButton';

/*
 * Props.
 */

interface CellsSearchAppliedQuerySuggestionProps {
  originalQuery: string;
  originalQueryNormalTerms: string;
  suggestedQueryNormalTerms: string;
  onAppliedQuerySuggestionClick: () => void;
  queryHash: string | undefined;

  className?: string;
}

/*
 * Component.
 */

export const CellsSearchAppliedQuerySuggestion: FC<CellsSearchAppliedQuerySuggestionProps> = (props) => {
  const {
    originalQuery,
    originalQueryNormalTerms,
    suggestedQueryNormalTerms,
    onAppliedQuerySuggestionClick,
    queryHash,
    className,
  } = props;

  const isQueryContainingFilters = originalQuery !== originalQueryNormalTerms;
  const noResultsText = isQueryContainingFilters ? (
    <Trans id="search-applied-query-suggestion-no-results-with-filters">
      No results for <b>{originalQueryNormalTerms}</b> with the selected filters.
    </Trans>
  ) : (
    <Trans id="search-applied-query-suggestion-no-results">
      No results for <b>{originalQueryNormalTerms}</b>.
    </Trans>
  );

  return (
    <InlineBanner
      className={className}
      layoutType={InlineBannerLayoutTypesEnum.INLINE}
      type={InlineBannerTypesEnum.INFO}
    >
      {noResultsText}{' '}
      <Trans id="search-applied-query-suggestion">
        Showing results for{' '}
        <InlineLinkButton
          onClick={onAppliedQuerySuggestionClick}
          interactionId="search-applied-typo-correction"
          interactionData={{query_hash: queryHash}}
        >
          <b>{suggestedQueryNormalTerms}</b>
        </InlineLinkButton>{' '}
        instead.
      </Trans>
    </InlineBanner>
  );
};
